'use client'

import { useKonamiCode } from '@/hooks/use-konami-code'
import { ReactNode } from 'react'

interface KonamiCodeProviderProps {
  children: ReactNode
}

/**
 * Provider component that enables Konami code Easter egg globally.
 * When the user enters: up, up, down, down, left, right, left, right, B, A
 * it toggles between modern and legacy store modes.
 */
export default function KonamiCodeProvider({ children }: KonamiCodeProviderProps) {
  // Initialize the Konami code listener
  useKonamiCode({
    showNotification: true,
  })

  return <>{children}</>
}
